export default __webpack_public_path__ + "static/media/vignesh.e5a6fec6.jpeg";